import { Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import DataWrapper from "../../../../common/components/DataWrapper/DataWrapper";
import { filterOptions, sortOptions } from "../../utils/customizeCovers";
import useRbac from "../../../../common/hooks/useRbac/useRbac";

const CustomizeCover = () => {
  const { checkPermission } = useRbac();
  const navigate = useNavigate();

  const endpoint = "cover-api/customize-covers/";

  const handleView = (row) => `${row.id}`;
  const handleEdit = (row) => `edit/${row.id}`;
  const handlePricesView = (row) => `${row.id}/pricing/`;
  const handleBenefitsView = (row) => `${row.id}/benefits/`;

  const config = {
    fields: [
      { key: "token", label: "Plan Code" },
      { key: "title", label: "Plan Name" },
      { key: "cover_scope", label: "Geo Scope" },
      // { key: "created_on", label: "Date", type: "datetime" },
      { key: "is_expired", label: "Status", type: "status" },
      { key: "created_by_name", label: "Created By" },
    ],
    actions: [
      { label: "View", to: (row) => handleView(row) },
      ...(checkPermission("update") ? [{ label: "Edit", to: (row) => handleEdit(row) }] : []),
      { label: "Price", to: (row) => handlePricesView(row) },
      { label: "Benefits", to: (row) => handleBenefitsView(row) },
    ],
    selectionActions: checkPermission("create")
    ? [
        {
          label: "+ Add Customized Plan",
          handler: () => {
            navigate("create");  
          },
        },
      ]
    : [],
    rowClickTo: (row) => handleView(row),
    doubleClickRow: true,
  };

  return (
    <>
    <Group align="center" gap="sm">
    </Group>
    <DataWrapper
      endpoint={endpoint}
      filterOptions={filterOptions}
      sortOptions={sortOptions}
      config={config}
      swrConfig={{ revalidateOnFocus: false, revalidateOnReconnect: false }}
      />
    </>
  );
};

export default CustomizeCover;